import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import firebase from 'firebase/app'
import 'firebase/auth'
import { defaultTheme, Provider } from '@adobe/react-spectrum'
import App from './App'
import './scss/index.scss'

firebase.initializeApp({
  apiKey: 'AIzaSyBnrddTL3LVrMlu0K4Z4u5wtQfAxQ7Fgj0',
  authDomain: 'app.konectsocial.com',
  projectId: 'konect-7e9af',
  storageBucket: 'konect-7e9af.appspot.com',
  messagingSenderId: '1085128028498',
  appId: '1:1085128028498:web:b8367f528c9f1f55638a8b',
})

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider theme={defaultTheme}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)
